import React from 'react';
import './App.css';
import Shop from './shop/Shop';
import { SiteAccessProvider } from './SiteAccessContext';

function App() {
  return (
    <SiteAccessProvider>
      <Shop />
    </SiteAccessProvider>
  );
}

export default App;
